<template>
  <div class="bigbox">
    <div
      class="product"
      v-for="(item,index) in productArr"
      @click="goto(item.links)"
    >
      <div class="product-box">
        <div class="default">
          <img :src="item.default">
          <div class="describe">
            <div class="describe1">{{item.describe1}}</div>
            <div class="describe2">{{item.describe2}}</div>
          </div>
        </div>
        <div class="active">
          <img :src="item.active">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { categoryDetails } from './detail';

export default {
  data() {
    return {
      productArr: []
    }
  },
  created() {
    this.productArr = categoryDetails
  },
  methods: {
    goto(a) {
      window.open(a)
    }
  }
}
</script>

<style lang="scss" scoped>
.head {
  img {
    width: 100%;
  }
}
.bigbox {
  display: flex;
  flex-wrap: wrap;
  animation: opcBox 1s ease-out;
}
.product {
  width: 33.333%;
  .product-box {
    width: 100%;
    position: relative;
    overflow: hidden;
    .default {
      cursor: pointer;
      width: 100%;
      img {
        width: 40rem;
        height: 50.0625rem;
      }
      .describe {
        width: 100%;
        height: 4.875rem;
        padding: 1.875rem 2.5rem;
        .describe1 {
          font-weight: 700;
          font-size: 1.5rem;
          padding-bottom: 0.9375rem;
          letter-spacing: 1px;
          color: #5e5e5e;
        }
        .describe2 {
          letter-spacing: 1.5px;
          font-weight: normal;
          color: #656565;
          font-size: 1.125rem;
        }
      }
    }
    .active {
      cursor: pointer;
      width: 100%;
      position: absolute;
      top: 0;
      right: -100%;
      transition: 0.6s;
      opacity: 0.5;
      img {
        width: 40rem;
        height: 50.0625rem;
      }
    }
  }
  .product-box:hover .active {
    transition: 1s;
    right: 0px;
    opacity: 1;
  }
}
.product:nth-of-type(11),
.product:nth-of-type(9) {
  .describe1 {
    text-indent: -1rem;
  }
}
.product:nth-of-type(15) {
  .describe2 {
    text-indent: -0.6rem;
  }
}
@keyframes opcBox {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>